import { AbstractControl, FormArray, FormGroup } from '@angular/forms';

export class CustomValidations {

  static MatchPassword(AC: AbstractControl) {
    const password = AC.get('password').value;
    const confirmPassword = AC.get('confirmPassword').value;
    if (password != confirmPassword) {
      AC.get('confirmPassword').setErrors({ MatchPassword: true });
    } else {
      return null;
    }
  }

  static CompareQuantity(AC: AbstractControl) {
    const waste = AC.get('wasteList').value;
    const wasteQuantity = waste.split(',');
    const totalCompost = Number(AC.get('totalCompost').value);
    const allowedQuantity: number = Math.floor(Number(wasteQuantity[1]) * 0.15);

    console.log('Allowed Compost >>>', allowedQuantity);

    if (totalCompost > Number(wasteQuantity[1])) {
      AC.get('baggedQuantity').setErrors({ InvalidQuantity: true });
      AC.get('unbaggedQuantity').setErrors({ InvalidQuantity: true });
    } else {
      if (totalCompost > Number(allowedQuantity)) {
        AC.get('totalCompost').setErrors({ QuantityNotAllowed: true });
      } else {
        return null;
      }
    }
  }
  static availabilityCheck(AC: AbstractControl) {
    const consumed = Number(AC.get('consumedUlb').value);
    const available = Number(AC.get('compostLeft').value);

    if (consumed > available) {
      AC.get('consumedUlb').setErrors({ InvalidQuantity: true });
    } else { return null; }
  }
}
